import { Responsive } from "./Responsive.svelte"

// useFadeMask.ts
export function mobileScrollFade(node: HTMLElement) {
	let isMobile = $state.snapshot(Responsive.isMobile)
	if (!isMobile) return

	node.classList.add("fade-mask")

	const updateMask = () => {
		const { scrollTop, scrollLeft, scrollHeight, scrollWidth, clientHeight, clientWidth } = node

		const hasTop = scrollTop > 0
		// + 1 was added to resolve an odd 1/2 pixel discrepency
		const hasBottom = scrollTop + 1 + clientHeight < scrollHeight
		const hasLeft = scrollLeft > 0
		const hasRight = scrollLeft + clientWidth < scrollWidth

		const classes = new Set<string>()

		if (hasTop) classes.add("fade-top")
		if (hasBottom) classes.add("fade-bottom")
		if (hasLeft) classes.add("fade-left")
		if (hasRight) classes.add("fade-right")

		node.classList.remove("fade-top", "fade-bottom", "fade-left", "fade-right")
		classes.forEach((cls) => node.classList.add(cls))
	}

	const observer = new ResizeObserver(updateMask)
	observer.observe(node)

	node.addEventListener("scroll", updateMask)
	updateMask()

	return {
		destroy() {
			observer.disconnect()
			node.removeEventListener("scroll", updateMask)
		},
	}
}
